import { useBEM } from './bem';
import { useSFC } from './sfc';
import { useI18N } from './i18n';
export function use(name) {
  name = 'van-' + name;
  return [useSFC(name), useBEM(name), useI18N(name)];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/utils/use/index.js
// module id = null
// module chunks = 